import { LegacyRef, useEffect, useState,useRef } from "react";
import {
  InputsContainer,
  Label,
} from "../../screens/complaint/Complaint.styled";
import ButtonPrimary from "../button.primary/button.primary.component";
import { BaseProps } from "./interfaces";
import {
  ButtonsContainer,
  OutputContainer,
  PropertyDetail,
  TabContainer,
} from "./move-inTabs.styled";

import Error from "../error";
import ErrorSubscription from "../../stores/ErrorSubscriptionStore";
import General from "../../stores/GeneralStore";
import ReCAPTCHA from "react-google-recaptcha";
import { Spinner, SpinnerRaw } from "../SpinnerRaw/SpinnerRaw";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import isEmpty from "../../../src/utils/objectNull";
interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  premise: Obj;
  ownerButton: Boolean;
  sewerageRef: LegacyRef<HTMLInputElement> | undefined;
  checkTenant: React.MouseEventHandler<HTMLButtonElement>;
  checkOwner: React.MouseEventHandler<HTMLButtonElement>;
  attempts: any;
  isRecaptchaVerified: any;
  setIsRecaptchaVerified: any;
  setAttempts: any;
  handleGetDetails: any;
  loading: Boolean;
  ownerLoading: Boolean;
  tenantLoader: Boolean;
  disabledBtn: any;
  setCaptchaToken:any
  resetCaptcha:any
  serviceActivation?: boolean;
  showDetails?: boolean;
}

export const Property = ({
  premise,
  sewerageRef,
  ownerButton,
  checkTenant,
  checkOwner,
  onClick,
  Next,
  handleGetDetails,
  attempts,
  isRecaptchaVerified,
  loading,
  setIsRecaptchaVerified,
  setAttempts,
  ownerLoading,
  tenantLoader,
  disabledBtn,
  setCaptchaToken,
  resetCaptcha,
  serviceActivation,
  showDetails
}: Props) => {
  const premiseDetailsErrorId = "propertySewerageError";
  const key: string = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

  useEffect(() => {
    ErrorSubscription.unSubscribeAll();
  }, []);

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  const validationSchema = Yup.object().shape({
    swerwge: Yup.string()
      .required(General?.codeLabels["cm_entersewno"]?.label)
      .matches(/^[0-9]+$/, General?.codeLabels["cm_numbererror"]?.label)
      .min(0, "Minimum value must be 0")
      .max(10, "Maximum value is 10"),
  });
  const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  useEffect(() => {
    if (resetCaptcha) {
      recaptchaRef.current?.reset();
    }
  }, [resetCaptcha]);
  useEffect(() => {
      localStorage.removeItem('premise');
      localStorage.removeItem('general');
    }, [])

  return (
    <>
      <TabContainer style={{ minHeight: "50vh" }}>
        <p
          style={{
            fontSize: `${0.8 * General.accessibility.fontSize}rem`,
            color: General.contrast.contrastColor
              ? General.contrast.contrastColor
              : General.ColorAss,
            marginTop: "20px",
            marginBottom: "20px",
          }}
          //className="DynamicTextColor"
        >
          {/* Enter your property details below to start your Move In (Tenancy
          Registration) */}
          {General?.codeLabels["cm_registration_flow"]?.label
            ? General?.codeLabels["cm_registration_flow"]?.label
            : "Enter your property details below to start your Move In (Tenancy Registration)"}
        </p>
        {/* <Error id={"propertySewerageError"} /> */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "1rem",
          }}
        >
          <Formik
            initialValues={{
              swerwge: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                // alert(JSON.stringify(values, null, 2));
                setSubmitting(false);
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,

              isSubmitting,
              /* and other goodies */
            }) => (
              <form onSubmit={handleSubmit}>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General.ColorAss,
                    width: "70%",
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                  //className="DynamicTextColor"
                >
                  {General?.codeLabels["cm_premiseid"]?.label !== undefined
                    ? General?.codeLabels["cm_premiseid"]?.label
                    : "Sewerage Number"}{" "}
                </Label>

                <div
                  style={{
                    width: General?.isLargeScreen ? "60%" : "100%",
                    display: "flex",
                    flexDirection: General?.isLargeScreen ? "row" : "column",
                    gap: "10px",
                    alignItems: General?.isLargeScreen ? "center" : "",
                    marginBottom: "1rem",
                  }}
                >
                  <div>
                    <Field
                      innerRef={sewerageRef}
                      type="number"
                      name="swerwge"
                      style={{
                        paddingLeft: ".3rem",
                        width: General?.isLargeScreen ? "317px" : "100%",
                        height: "46px",
                        background: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        color: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : General.ColorAss,
                        // border:`1px solid ${contrast?.contrastColor
                        // ? contrast?.contrastColor
                        // : General.ColorAss}`,
                      }}
                      className="DynamicInput"
                    />
                    <div
                      style={{
                        height: General?.isLargeScreen ? "0.5rem" : "1rem",
                      }}
                    >
                      <ErrorMessage
                        name="swerwge"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <div>
                    <ButtonPrimary
                      label={
                        loading
                          ? ""
                          : General?.codeLabels["cm_registration_get_details"]
                              ?.label
                          ? General?.codeLabels["cm_registration_get_details"]
                              ?.label
                          : "GET DETAILS"
                      }
                      styles={{
                        background: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss || "#101E8E",
                        color: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "white",
                        alignSelf: "flex-end",
                        width: General?.isLargeScreen ? "12rem" : "100%",
                        height: "47px",
                        justifyContent: "center",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        zIndex: 0,
                        opacity:
                          !isRecaptchaVerified ? "0.5" : "1",
                        whiteSpace: "nowrap",
                      }}
                      onClick={() => {
                        if (isEmpty(errors)) handleGetDetails();
                      }}
                      disabled={
                        loading
                          ? true
                          : false || (!isRecaptchaVerified )
                      }
                    >
                      {loading && <Spinner width="30px" height="30px" />}
                    </ButtonPrimary>
                    <div style={{ height: "0.5rem" }}></div>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>

        {/* {!isRecaptchaVerified && attempts >= 3 && ( */}
          <ReCAPTCHA
            sitekey={key}
            ref={recaptchaRef}
            onChange={(response) => {
              if (response) {
                // console.log("Captcha value:", response);
                setCaptchaToken(response);
                setIsRecaptchaVerified(true);
                setAttempts(0);
              }
            }}
          onExpired={() => setIsRecaptchaVerified(false)}

          />
        {/* )} */}

        {premise && premise?.premiseId&& showDetails && (
          <>
            <OutputContainer>
              <PropertyDetail>
                <b
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                    marginTop: "1rem",
                  }}
                  //className="DynamicTextColor"
                >
                  {General?.codeLabels["cm_propertydet"]?.label !== undefined
                    ? General?.codeLabels["cm_propertydet"]?.label
                    : "Property Details"}
                </b>
                <span
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                  }}
                  className="DynamicTextColor"
                >
                  {premise.premiseDetails}
                </span>
              </PropertyDetail>
              <PropertyDetail>
                <b
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                  }}
                  className="DynamicTextColor"
                >
                  {General?.codeLabels["cm_propertyusage"]?.label !== undefined
                    ? General?.codeLabels["cm_propertyusage"]?.label
                    : "Property Usage"}
                </b>
                <span
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                  }}
                  className="DynamicTextColor"
                >
                  {premise.premiseUsage}
                </span>
              </PropertyDetail>
            </OutputContainer>
            <hr style={{ width: "100%" }} />
            <ButtonsContainer
              style={{
                gap: "1rem",
                flexDirection: General?.isLargeScreen ? "row" : "column",
                width: General?.isLargeScreen ? "80%" : "100%",
              }}
            >
              {
                // premise.ownerAccount && ownerButton
                ownerButton ? (
                  // <ButtonPrimary
                  //   label="I AM THE OWNER OF THIS PROPERTY"
                  //   styles={{
                  //     color: contrast?.contrastColor
                  //       ? contrast?.contrastColor
                  //       : "#fff",
                  //     width: "50%",
                  //     height: "3.4rem",
                  //     fontSize: `${General.accessibility.fontSize}rem`,
                  //   }}
                  //   onClick={checkOwner}
                  // />
                  <ButtonPrimary
                    label={
                      ownerLoading
                        ? ""
                        : General?.codeLabels["cm_registratio_owner"]?.label
                        ? General?.codeLabels["cm_registratio_owner"]?.label
                        : "I AM THE OWNER OF THIS PROPERTY"
                    }
                    styles={{
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss || "#101E8E",
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "white",
                      width: General?.isLargeScreen ? "50%" : "100%",
                      height: "3.4rem",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      zIndex: 0,
                      opacity:
                        disabledBtn || (!isRecaptchaVerified && attempts >= 3)
                          ? "0.5"
                          : "1",
                      justifyContent: "center",
                      alignSelf: "flex-end",
                      whiteSpace: "nowrap",
                    }}
                    onClick={checkOwner}
                    disabled={
                      disabledBtn || (!isRecaptchaVerified && attempts >= 3)
                    }
                  >
                    {ownerLoading && <Spinner width="30px" height="30px" />}
                  </ButtonPrimary>
                ) : null
              }
              {
                // !premise.tenantAccount ?
                serviceActivation ? null :
                <ButtonPrimary
                  label={
                    tenantLoader
                      ? ""
                      : General?.codeLabels["cm_registration_tenant"]?.label
                      ? General?.codeLabels["cm_registration_tenant"]?.label
                      : "I AM THE TENANT OF THIS PROPERTY"
                  }
                  styles={{
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss || "#101E8E",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "white",
                    width: General?.isLargeScreen ? "50%" : "100%",
                    height: "3.4rem",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    opacity:
                      disabledBtn || (!isRecaptchaVerified && attempts >= 3)
                        ? "0.5"
                        : "1",
                    justifyContent: "center",
                    alignSelf: "flex-end",
                    whiteSpace: "nowrap",
                  }}
                  onClick={checkTenant}
                  disabled={
                    disabledBtn || (!isRecaptchaVerified && attempts >= 3)
                  }
                >
                  {tenantLoader && <Spinner width="30px" height="30px" />}
                </ButtonPrimary>
                // : null
              }
            </ButtonsContainer>
          </>
        )}
      </TabContainer>
    </>
  );
};
